import { useEffect, useState } from "react";

const formatAgo = (ts) => {
  if (!ts) return "";
  const seconds = Math.max(0, Math.floor((Date.now() - ts) / 1000));
  if (seconds < 2) return "Updated just now";
  if (seconds < 60) return `Updated ${seconds}s ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `Updated ${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  return `Updated ${hours}h ago`;
};

export const LastUpdated = ({ timestamp, testId, light }) => {
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!timestamp) return;
    const id = window.setInterval(() => setTick((t) => t + 1), 1000);
    return () => window.clearInterval(id);
  }, [timestamp]);

  if (!timestamp) return null;

  return (
    <span
      data-testid={testId || "last-updated-indicator"}
      className={`inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap text-xs font-semibold ${light ? "text-white/60" : "text-slate-400 dark:text-slate-500"}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 animate-pulse" />
      {formatAgo(timestamp)}
    </span>
  );
};
